import styles from "./TrainModel.module.scss";
import {
  CheckOutlined,
  ClockCircleOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import classNames from "classnames";
import { ReactNode } from "react";
import VLTooltip from "../../../uikit/VLTooltip";

const ICON_BY_STATUS: Record<string, ReactNode> = {
  INIT: <ClockCircleOutlined />,
  IN_PROGRESS: <LoadingOutlined />,
  COMPLETED: <CheckOutlined />,
  FAILED: <CloseOutlined />,
  CANCELLED: <CloseOutlined />,
  TRAIN_WORTHY: <CheckOutlined className={styles.worthyIcon} />,
};

export const TrainingStatusView = ({
  status,
  text,
  action,
  tooltip,
  onClick,
}: {
  tooltip?: ReactNode;
  status: keyof typeof ICON_BY_STATUS;
  text: string;
  action?: ReactNode;
  onClick?: () => void;
}) => {
  const trainingStatusClass = classNames(
    styles.trainingStatus,
    styles[status],
    onClick && styles.clickable,
  );
  const statusClass = classNames(
    styles.statusText,
    onClick && styles.clickable,
  );

  return (
    <VLTooltip title={tooltip}>
      <div className={trainingStatusClass} onClick={onClick}>
        <IconWithText
          icon={ICON_BY_STATUS[status]}
          text={text}
          className={statusClass}
        />
        {action}
      </div>
    </VLTooltip>
  );
};

const IconWithText = ({
  icon,
  text,
  className,
}: {
  icon: ReactNode;
  text: string;
  className: string;
}) => (
  <>
    {icon}
    <div className={className}>{text}</div>
  </>
);
